/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_BoatsInputs */

const es_nav_boats = /** @type {(inputs: Nav_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barcos`)
};

const gl_nav_boats = /** @type {(inputs: Nav_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barcos`)
};

const en_nav_boats = /** @type {(inputs: Nav_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boats`)
};

/**
* | output |
* | --- |
* | "Boats" |
*
* @param {Nav_BoatsInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_boats = /** @type {((inputs?: Nav_BoatsInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_BoatsInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_boats(inputs)
	if (locale === "en") return en_nav_boats(inputs)
	return es_nav_boats(inputs)
});